function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import IconButton from '../../iconButton/IconButton';
import { STYLE_PROP_TYPE as ICON_BUTTON_STYLE_PROPTYPE, ICON_PROP_TYPE as ICON_BUTTON_ICON_PROPTYPE } from '../../iconButton/constants';

var MediaCardAction = function MediaCardAction(_ref) {
  var iconType = _ref.iconType,
      style = _ref.style,
      title = _ref.title,
      secondary = _ref.secondary,
      onClick = _ref.onClick,
      dropdown = _ref.dropdown,
      isConsumer = _ref.isConsumer;
  var component = null;
  var iconClassName = classNames('eds-media-card-content__actions-container__action eds-l-pad-all-1', {
    'eds-l-mar-right-2': secondary,
    'eds-media-card-content__actions-icon--primary': !secondary && isConsumer,
    'eds-media-card-content__actions-icon--secondary': isConsumer && secondary
  });

  if (iconType) {
    component = React.createElement("span", {
      className: iconClassName
    }, React.createElement(IconButton, {
      title: title,
      style: style,
      iconType: iconType,
      onClick: onClick
    }), dropdown);
  }

  return component;
};

var MediaCardActions =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MediaCardActions, _PureComponent);

  function MediaCardActions() {
    _classCallCheck(this, MediaCardActions);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediaCardActions).apply(this, arguments));
  }

  _createClass(MediaCardActions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          primaryIconType = _this$props.primaryIconType,
          primaryIconStyle = _this$props.primaryIconStyle,
          primaryIconTitle = _this$props.primaryIconTitle,
          primaryIconOnClick = _this$props.primaryIconOnClick,
          primaryIconDropdown = _this$props.primaryIconDropdown,
          secondaryIconType = _this$props.secondaryIconType,
          secondaryIconStyle = _this$props.secondaryIconStyle,
          secondaryIconTitle = _this$props.secondaryIconTitle,
          secondaryIconOnClick = _this$props.secondaryIconOnClick,
          isConsumer = _this$props.isConsumer,
          shouldShowIcons = _this$props.shouldShowIcons;
      var classes = classNames('eds-media-card-content__actions-container', {
        'eds-media-card-content__actions-container--always-visible': shouldShowIcons,
        'eds-media-card-content__actions-container--consumer': isConsumer
      });
      return React.createElement("div", {
        className: classes
      }, React.createElement(MediaCardAction, {
        iconType: secondaryIconType,
        style: secondaryIconStyle,
        title: secondaryIconTitle,
        onClick: secondaryIconOnClick,
        secondary: secondaryIconType,
        isConsumer: isConsumer
      }), React.createElement(MediaCardAction, {
        iconType: primaryIconType,
        style: primaryIconStyle,
        title: primaryIconTitle,
        onClick: primaryIconOnClick,
        dropdown: primaryIconDropdown,
        isConsumer: isConsumer
      }));
    }
  }]);

  return MediaCardActions;
}(PureComponent);

_defineProperty(MediaCardActions, "propTypes", {
  primaryIconType: ICON_BUTTON_ICON_PROPTYPE,
  primaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
  primaryIconTitle: EBPropTypes.translation,
  primaryIconOnClick: PropTypes.func,
  primaryIconDropdown: PropTypes.node,
  secondaryIconType: ICON_BUTTON_ICON_PROPTYPE,
  secondaryIconStyle: ICON_BUTTON_STYLE_PROPTYPE,
  secondaryIconTitle: EBPropTypes.translation,
  secondaryIconOnClick: PropTypes.func,
  shouldShowIcons: PropTypes.bool,
  isConsumer: PropTypes.bool
});

export { MediaCardActions as default };